import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { AircraftPopupContainerComponent } from '../../../aircraft-popup-container/aircraft-popup-container.component';
import { Aircraftwatch } from 'src/app/models/flight-watch';

export interface AicraftPopUpDialogData {
    fboId: number;
    flightData: Aircraftwatch;
    groupId: number;
    showFavoriteButton: boolean;
}

@Component({
    selector: 'app-aircraft-data-dialog',
    templateUrl: './aircraft-data-dialog.component.html',
    styleUrls: ['./aircraft-data-dialog.component.scss'],
})
export class AircraftDataDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<AircraftPopupContainerComponent>,
        @Inject(MAT_DIALOG_DATA) public data: AicraftPopUpDialogData
    ) {
        dialogRef.beforeClosed().subscribe(() => {
              dialogRef.close(this.data.flightData);
          });
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}
